export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-4">
            联系我们
          </h2>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8">
            无论您是想投稿影视资源、反馈播放问题，还是寻求商务合作，
            6080新视觉影视团队都欢迎您的来信。我们将尽快回复每一条留言。
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
            <div className="bg-background-50 rounded-xl p-6 text-center border border-background-200">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 mb-3">
                <i className="ri-mail-line text-primary-500 text-xl"></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-950 text-sm mb-1">投稿邮箱</h3>
              <p className="text-xs text-foreground-500">contact@6080ys.com</p>
            </div>
            <div className="bg-background-50 rounded-xl p-6 text-center border border-background-200">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 mb-3">
                <i className="ri-wechat-line text-accent-500 text-xl"></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-950 text-sm mb-1">微信公众号</h3>
              <p className="text-xs text-foreground-500">6080新视觉影视</p>
            </div>
            <div className="bg-background-50 rounded-xl p-6 text-center border border-background-200">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-secondary-100 mb-3">
                <i className="ri-discuss-line text-secondary-500 text-xl"></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-950 text-sm mb-1">在线反馈</h3>
              <p className="text-xs text-foreground-500">页面底部留言</p>
            </div>
          </div>

          <button
            type="button"
            className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-send-plane-line mr-2"></i>
            立即投稿
          </button>
        </div>
      </div>
    </section>
  );
}